import { RadioButtonField as UnstyledRadioButtonField, withClassName } from '@epages/react-components'

export default withClassName('ep-form-row-radio-group')(UnstyledRadioButtonField)
